import React from 'react';
import PropTypes from 'prop-types';

import TagView from 'core/gd-components/icons/tag/tag-view'
import VScroll from 'src/core/gd-components/scrolling/custom-v-scroll/v-scroll';
import SearchInput from "core/gd-ui/search/search";
import ModalV4HeaderWhite from "src/app/ui/modal/v4/header-white/v4-header-white";

export default class RemoveTagExisting extends React.Component {
    static propTypes = {
        params: PropTypes.object.isRequired,

        onRemoveTag: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.state = {
            searchString: ''
        }

        const { companyId, tags } = this.props.params;

        this.allOptions = [];
        gd.session.projects.filterByCompany(companyId).filterBySystemType(gd.const.project.type.TAG).map(t=>{
            if (t.isArchived || !tags.includes(t.id)) return;
            this.allOptions.push(t);
        });
        this.allOptions = _.sortBy(this.allOptions, [function(o) { return o.name.toLowerCase(); }]);

    }

    onTagClick = (tagId) => {
        const project = gd.session.projects.get(tagId);
        const message = (
            <div className="message">
                <div className="txt">Are you sure that you want to remove tag</div>
                {project && <div className="highlight">{project.name}</div>}
                <div className="txt">from the selected items?</div>
            </div>
        );

        gd.modals.confirm.generic('Untag',message,()=>{
            this.props.onRemoveTag(tagId)
        });
    }

    onSearchChange = (searchString) => {
        this.setState({
            'searchString': searchString
        })
    }

    renderTags = () => {
        let options = [];

        this.allOptions.map(tag=>{
            if (!this.state.searchString || gd.utils.search(tag.name, this.state.searchString)) {
                options.push(tag);
            }
        })

        return (
            <div className="tags-list">
                {(!options || options.length<1) &&<div className="not-found">No tags found</div>}
                {options.map((tag,key) => <TagView key={key} tag={tag} size="26" onClick={this.onTagClick.bind(this, tag.id)} showIcon />)}
                <div className="cf"/>
            </div>
        )
    }

    render() {
        return (
            <div className="v4-container placement-middle select-existing" onClick={this.props.onClick}>
                <ModalV4HeaderWhite height={60} title="Select a Tag" />
                <div className="main">
                    <VScroll containerClass="main-container">
                        <div className="search">
                            <SearchInput onChange={this.onSearchChange} value={this.state.searchString} />
                        </div>
                        {this.renderTags()}
                    </VScroll>
                </div>
            </div>
        );
    }
}